import { Flex, pxToRem } from '@archipro-design/aria';
import { ManageDesignBoardDropdown } from '@modules/design-board/component/manage/ManageDropdown';
import { useDesignBoardCollaboratorsContext } from '@modules/design-board/component/manage/collaborator-overview/context/DesignBoardCollaboratorsContext';
import classNames from 'classnames';
import type {
    Access,
    InviteStatus,
} from '@modules/design-board/component/manage/collaborator-overview/CollaboratorOverview.types';

interface ActionMenuOptionProps {
    render: string;
    id: string;
    onclick?: () => void;
}

interface ActionMenuProps {
    email: string;
    access: Access;
    inviteStatus: InviteStatus;
    options?: ActionMenuOptionProps[];
    variant?: 'text' | 'button';
    noChevron?: boolean;
    hug?: 'left' | 'right' | 'none';
}

export const ActionMenu = ({
    access,
    options = [],
    email,
    inviteStatus,
    noChevron = false,
    hug = 'none',
}: ActionMenuProps) => {
    const context = useDesignBoardCollaboratorsContext();
    return (
        <Flex
            hAlign={'end'}
            design={{
                position: 'absolute',

                paddingRight: pxToRem(-4),
                ...(hug === 'left' && { left: 0 }),
                ...(hug === 'right' && { right: 0 }),
            }}
            className={classNames('ActionMenu__Root')}
        >
            <ManageDesignBoardDropdown
                noChevron={noChevron}
                variant={'no-padding'}
                defaultSelectedIndex={
                    options?.findIndex((opt) => opt?.id === access) ?? 0
                }
                items={[
                    ...options,
                    {
                        id: 'action_remove_collaborator',
                        type: 'action',
                        onClick: () =>
                            context.dispatch({
                                type: 'show-remove-collaborator-confirmation',
                                data: {
                                    email,
                                    inviteStatus,
                                },
                            }),
                        render: (
                            <Flex
                                className={'ActionMenu__RemoveWrapper'}
                                design={{
                                    width: '100%',
                                    height: '100%',
                                }}
                            >
                                Remove
                            </Flex>
                        ),
                    },
                ]}
            />
        </Flex>
    );
};
